<script setup lang="ts">
import {computed} from "vue";

interface Props {
    status: number
}

const props = defineProps<Props>();

const title = computed(() => {
    switch (props.status) {
    case 503:
        return 'Taking a coffee break...'
    case 500:
        return 'Our engineers are working hard!'
    case 404:
        return 'This page is lost in space...'
    case 403:
        return 'You Shall Not Pass!'
    default:
        return 'Error'
    }

})

const description = computed(() => {
    switch (props.status) {
    case 503:
        return 'Sorry, we are doing some maintenance. Please check back soon.'
    case 500:
        return 'Whoops, something went wrong on our servers.'
    case 404:
        return 'Sorry, the page you are looking for could not be found.'
    case 403:
        return 'Sorry, you are forbidden from accessing this page.'
    default:
        return 'An error occurred.'
    }
})
</script>

<template>
    <v-sheet
        height="100"
        class="mt-15 d-flex align-center fill-height justify-center text-center bg-transparent"
    >
        <v-card
            variant="flat"
            class="px-1 bg-transparent"
        >
            <v-card-text>
                <p class="text-h2 font-weight-medium">
                    {{ title }}
                </p>
                <p class="text-h5 font-weight-regular text-disabled px-10 pt-5">
                    {{ description }}
                </p>
            </v-card-text>
            <div class="text-center ma-5">
                <img
                    v-if="status === 404"
                    src="@/assets/404.png"
                    alt="404 Not Found"
                    class="banner-image"
                >
                <img
                    v-if="status === 403"
                    src="@/assets/403.png"
                    alt="403 Forbidden"
                    class="banner-image"
                >
                <img
                    v-if="status === 500"
                    src="@/assets/500.png"
                    alt="500 Server Error"
                    class="banner-image"
                >
                <img
                    v-if="status === 503"
                    src="@/assets/503.png"
                    alt="503 Service Unavailable"
                    class="banner-image"
                >
            </div>
            <v-card-actions
                v-if="status !== 503"
                class="justify-center"
            >
                <v-btn
                    variant="text"
                    size="large"
                    rounded="lg"
                    color="base"
                    class="text-none text-body-2"
                    href="/"
                >
                    Go back
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-sheet>
</template>

<style scoped>
.banner-image {
    max-width: 650px;
    height: auto;
}
</style>
